
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/c9341bd20856c77713d7fd5e1216a8ac.jpg"
          alt="Compassionate home care"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <h1 className="text-7xl font-serif font-medium text-white mb-6 leading-tight">
          Compassionate Care<br />
          In The Comfort of Home
        </h1>

        <p className="text-xl text-white/95 font-light mb-12 max-w-3xl mx-auto leading-relaxed">
          Professional non-medical home care services<br />
          tailored to your loved ones' unique needs
        </p>

        <div className="flex items-center justify-center gap-4">
          <button 
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-[#6B8E6F] text-white rounded-full font-medium hover:bg-[#5a7a5e] transition-all whitespace-nowrap cursor-pointer"
          >
            Schedule Consultation
          </button>
          <button 
            onClick={() => scrollToSection('services')}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full font-medium hover:bg-white/20 transition-all border-2 border-white/50 whitespace-nowrap cursor-pointer"
          >
            Our Services
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
